import React, { useEffect, useState } from "react";
import { FileListData } from "../network/api/FileListData";
import PaginationSmall from "../../../components/PaginationSmall";
import Alerts from "../../../components/Alerts";
import { FileData } from "../network/api/FileData";

const getPreviewSrc = (file) => {
    const ext = file.name.split('.').pop().toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
        return file.file_url;
    }
    if (ext === 'pdf') return '/assets/icons/file-icons/pdf-icon.png';
    if (['doc', 'docx'].includes(ext)) return '/assets/icons/file-icons/docx-icon.png';
    if (['zip', 'rar', '7z'].includes(ext)) return '/assets/icons/file-icons/zip-icon.png';
    if (ext === 'mp4') return '/assets/icons/file-icons/video-icon.png';
    return '/assets/icons/file-icons/file-icon-2.png';
};

export default function FileManager({ ownerId, fileData = null, setFileData = null }) {
    const [files, setFiles] = useState([]);
    const [pageFilters, setPageFilters] = useState({
        page: null,
        type: "image",
        limit: 6,
    });

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: [],
    });

    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleDelete = async (file) => {
        setIsLoading(true);
        setErrorMessage(null);

        try {
            const response = await FileData({ method: "DELETE", id: file.id });

            if (response.status === "success") {
                setFiles((prev) => prev.filter((f) => f.id !== file.id));
            } else {
                setErrorMessage({ status: response.status, message: response.message });
            }
        } catch (error) {
            setErrorMessage({ status: 400, message: "An error occurred while deleting the file" });
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {

        const fetchFiles = async () => {
            setIsLoading(true);
            setErrorMessage(null);

            try {
                const response = await FileListData({ ownerId: ownerId, pageFilters });
                //console.log("FileListData response", ownerId);

                if (response.status === "success") {
                    if (JSON.stringify(response.data.data) !== JSON.stringify(files)) {
                        setFiles(response.data.data);

                        setPageProps({
                            page: response.data.page,
                            totalPages: response.data.total_pages,
                            totalEntries: response.data.total_records,
                            entryLimit: response.data.limit,
                            visiblePages: response.data.visible_pages,
                        })
                    }
                } else {
                    setErrorMessage({ status: response.status, message: response.message });
                }
            } catch (error) {
                setErrorMessage({ status: 400, message: "An error occurred while fetching files" });
            } finally {
                setIsLoading(false);
            }
        }
        fetchFiles();

    }, [ownerId, files, pageFilters, fileData]);

    return (
        <div className="card">
            <div className="card-body ">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    {/*<h5 className="text-primary d-inline">File Manager</h5>*/}
                    <ul className="nav nav-tabs card-header-tabs">
                        <li className="nav-item">
                            <button className={`nav-link  ${pageFilters.type === "image" ? "active" : "text-primary"}`} onClick={() => setPageFilters((prev) => ({ ...prev, type: "image" }))}>Images</button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${pageFilters.type === "video" ? "active" : "text-primary"}`} onClick={() => setPageFilters((prev) => ({ ...prev, type: "video" }))}>Videos</button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${pageFilters.type === "document" ? "active" : "text-primary"}`} onClick={() => setPageFilters((prev) => ({ ...prev, type: "document" }))}>Docs</button>
                        </li>
                        <li className="nav-item">
                            <button className={`nav-link ${pageFilters.type === "archive" ? "active" : "text-primary"}`} onClick={() => setPageFilters((prev) => ({ ...prev, type: "archive" }))}>Archives</button>
                        </li>
                    </ul>
                </div>
                {(!isLoading && errorMessage) && (
                    <Alerts type={errorMessage?.status === "success" ? "success" : "danger"} message={errorMessage?.message} visible={errorMessage} />
                )}

                <div className="profile-interest">
                    <div className="row mt-4 col-12 sp4">
                        {(files.length === 0 && !errorMessage) && (
                            <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                <i className="fa fa-folder-open text-muted mb-3" style={{ fontSize: "4rem" }}></i>
                                <h4 className="text-muted">{pageFilters.type} Empty!</h4>
                            </div>
                        )}
                        {files.length > 0 && files.map((file, index) => (
                            <div className="mx-auto d-block col-lg-4 col-xl-4 col-sm-3 col-4 mb-4 position-relative" key={index}>
                                <img
                                    src={getPreviewSrc(file)}
                                    className="img-fluid rounded"
                                    alt={file?.description}
                                    style={{ width: "100%", objectFit: "cover", objectPosition: "center" }}
                                />
                                <div className="dropdown ms-auto position-absolute top-0 end-0 m-2">
                                    <a href="/" onClick={(e)=>e.preventDefault() } className="btn btn-primary light sharp" data-bs-toggle="dropdown" aria-expanded="false">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <rect x="0" y="0" width="24" height="24"></rect>
                                                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                            </g>
                                        </svg>
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <li className="dropdown-item"><a href="/"  onClick={(e) =>{e.preventDefault(); window.open(file?.file_url, "_blank");}}><i className="fa fa-download text-primary me-2"></i>Download</a></li>
                                        <li className="dropdown-item"><a href="/" onClick={(e) =>{e.preventDefault(); setFileData(file)}}><i className="fa fa-pencil text-primary me-2"></i>Use</a></li>
                                        <li className="dropdown-item"><a href="/" onClick={(e) =>{e.preventDefault(); handleDelete(file);}}><i className="fa fa-trash text-danger me-2"></i>Delete</a></li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {files.length > 0 && (
                    <PaginationSmall pageProps={pageProps} onPageChange={(page) => setPageFilters((prev) => ({ ...prev, page }))} />
                )}

            </div>
        </div>
    );
}